import React from 'react';
import classNameBind from 'classnames/bind';
import Skeleton from '../../../Skeleton';
import styles from './ElementsLoading.module.css';

const bindClasses = classNameBind.bind(styles);

const ElementsLoading = ({ count = 10 }) => (
  <div
    className={bindClasses('wrapper')}
    data-ppuc-id="Sidebar.ElementsLoading"
  >
    {new Array(count).fill().map((v, i) => (
      <Skeleton width={`${Math.random() * 50 + 30}%`} height="16px" key={i} />
    ))}
  </div>
);

export default ElementsLoading;
